import { Stack, IContextualMenuProps, IButtonStyles, getTheme, HighContrastSelector } from '@fluentui/react';
import React, { useContext } from 'react';
import { trackEvent } from '../../../services';
import { ReviewContext } from '../../review/ReviewContextProvider';
import { borderTopStyle } from '../BorderStyles';
import { SalusPrimaryButton } from '../SalusPrimaryButton';
import { WhiteStatic } from 'theme';

export interface SubmitButtonsProps {
  isEnabled: boolean;
  multipleCases: boolean;
  onClickAndExit: () => void;
  onClickAndNext: () => void;
}

export const SubmitButtons: React.FunctionComponent<SubmitButtonsProps> = props => {
  const { state } = useContext(ReviewContext);
  const { palette, fonts } = getTheme();
  const borderTop = borderTopStyle(palette);
  const buttonStyle: Partial<IButtonStyles> = {
    label: {
      fontSize: fonts.mediumPlus.fontSize,
      fontFamily: fonts.mediumPlus.fontFamily,
      lineHeight: fonts.mediumPlus.lineHeight,
      fontWeight: 'normal'
    },
    rootDisabled: {
      color: palette.white,
      backgroundColor: palette.neutralQuaternary
    }
  };
  const menuProps: IContextualMenuProps = {
    useTargetWidth: false,
    styles: {
      root: { backgroundColor: palette.neutralLight }
    },
    items: [
      {
        key: 'submitAndExit',
        text: 'Submit & exit',
        onClick: props.onClickAndExit
      }
    ]
  };
  const nextCaseText = props.multipleCases ? 'Submit set & view next set' : 'Submit & view next';
  const onClick = () => {
    trackEvent('SubmitCasesEvent', {
      component: 'SubmitButton',
      eventType: 'click',
      caseIds: state.cases?.map(elem => elem?.case.id),
      caseCount: state.cases.length,
      timeElapsed: state.timeElapsed,
      queueId: state.queue?.id,
      tenantId: state.queue?.tenant.tenantId,
      titleId: state.queue?.title.titleId,
      subjectType: state.queue?.subjectType,
      queueConfigVersion: state.queue?.revision
    });
    props.onClickAndNext();
  };

  return (
    <Stack horizontal className="p-4 text-align-center text-nowrap" style={borderTop}>
      <Stack horizontal>
        <SalusPrimaryButton
          primary
          styles={{
            ...buttonStyle,
            root: { padding: '1.25rem 0.75rem 1.25rem 0.75rem', marginRight: 1, borderRadius: '6px 0 0 6px !important' }
          }}
          disabled={!props.isEnabled}
          onClick={onClick}
          text={nextCaseText}
        />
        <SalusPrimaryButton
          ariaLabel={'More options'}
          disabled={!props.isEnabled}
          styles={{
            ...buttonStyle,
            root: {
              padding: '1.25rem 0.25rem 1.25rem 0.25rem',
              minWidth: '20px',
              borderRadius: '0 6px 6px 0 !important'
            },
            menuIcon: {
              color: WhiteStatic,
              selectors: {
                [HighContrastSelector]: {
                  color: 'inherit !important'
                }
              }
            }
          }}
          menuProps={menuProps}
        />
      </Stack>
    </Stack>
  );
};
